<ng-container *ngIf="dataGroupItemInstance.dataTable[0]?.data.length">
  <app-report-quote *ngIf="reportType === 'quote'" [data]="dataGroupItemInstance.dataTable[0].data[0].reportJSON.reportContent"/>
</ng-container>
